import { ThunkAction } from 'redux-thunk'
import { Action, Store } from 'redux'

import { apiCall, METHOD } from '../../service/baseApiCall'
import {
  GET_ASSIGN_BATCH_LIST,
  GET_ASSIGN_TO_BATCH_SKILL_MATCH,
  GET_JD_DETAILS,
  GET_JD_LIST,
  GET_RESUME_FILE,
  RESUME_ACTIVITY,
  RESUME_ASSIGN_TO_BATCH,
  RESUME_BULK_BOOKMARK,
  RESUME_BULK_DELETE,
  RESUME_BULK_DOWNLOAD,
  RESUME_LIBRARY,
  RESUME_LIBRARY_ASSIGN_HISTORY,
  RESUME_LIBRARY_DETAIL,
} from '../constants/action-types'
import {
  ASSIGN_TO_BATCH_LIST_URL,
  ASSIGN_TO_BATCH_SKILL_MATCH_URL,
  GET_RESUME_LINK_URL,
  JD_DETAILS_URL,
  JD_LIST_URL,
  RESUME_ACTIVITY_URL,
  RESUME_ASSIGN_TO_BATCH_URL,
  RESUME_BULK_BOOKMARK_URL,
  RESUME_BULK_DELETE_URL,
  RESUME_BULK_DOWNLOAD_URL,
  RESUME_LIBRARY_ASSIGN_HISTORY_URL,
  RESUME_LIBRARY_DETAIL_URL,
  RESUME_LIBRARY_LIST_URL,
} from '../../service/apiEndPoints'
import { showErrorToastMessage } from '../../util/utils'

/**
 * resume list
 * @returns
 */
const getResumeLibraryListThunk =
  (
    is_invited: any,
    page?: number,
    userId?: any,
    is_saved?: any,
    exclude_user?: any,
    jobTitle?: any,
    skillKeyword?: any,
    minExp?: number,
    maxExp?: number | undefined,
    sorting?: string,
    lastDay?: any,
    not_attempted?: any,
    is_selected?: any,
    is_rejected?: any,
    job_description?: any
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: RESUME_LIBRARY.RESUME_LIBRARY_LIST_INITIALIZATION,
    })
    apiCall(
      RESUME_LIBRARY_LIST_URL,
      (res: any) => {
        dispatch({
          type: RESUME_LIBRARY.RESUME_LIBRARY_LIST_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: RESUME_LIBRARY.RESUME_LIBRARY_LIST_ERROR,
        })
      },
      {
        params: {
          is_invited: true,
          page: page,
          created_by: userId ? userId : undefined,
          is_saved: is_saved ? is_saved : undefined,
          job_title: jobTitle?.length ? JSON.stringify(jobTitle) : undefined,
          skill: skillKeyword?.length
            ? JSON.stringify(skillKeyword)
            : undefined,
          total_experience_min: minExp ? minExp : undefined,
          total_experience_max: maxExp ? maxExp : undefined,
          ordering: sorting ? sorting : undefined,
          exclude_user: exclude_user ? exclude_user : undefined,
          created_at_after: lastDay ? lastDay : undefined,
          not_attempted: not_attempted ? not_attempted : undefined,
          is_selected: is_selected ? is_selected : undefined,
          is_rejected: is_rejected ? is_rejected : undefined,
          job_description: job_description ? job_description : undefined,
        },
      },
      METHOD.GET,
      { showToast: false }
    )
  }

/**
 * resume details
 * @param resumeId
 * @returns
 */
const getResumeDetailThunk =
  (resumeId): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: RESUME_LIBRARY_DETAIL.RESUME_LIBRARY_DETAIL_INITIALIZATION,
    })
    apiCall(
      RESUME_LIBRARY_DETAIL_URL(resumeId),
      (res: any) => {
        dispatch({
          type: RESUME_LIBRARY_DETAIL.RESUME_LIBRARY_DETAIL_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: RESUME_LIBRARY_DETAIL.RESUME_LIBRARY_DETAIL_ERROR,
        })
      },
      {},
      METHOD.GET,
      { showToast: false }
    )
  }

/**
 * assign history
 * @param resumeId
 * @returns
 */
const getResumeAssignHistoryThunk =
  (resumeId, page): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: RESUME_LIBRARY_ASSIGN_HISTORY.RESUME_LIBRARY_ASSIGN_HISTORY_INITIALIZATION,
    })
    apiCall(
      RESUME_LIBRARY_ASSIGN_HISTORY_URL(resumeId),
      (res: any) => {
        dispatch({
          type: RESUME_LIBRARY_ASSIGN_HISTORY.RESUME_LIBRARY_ASSIGN_HISTORY_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: RESUME_LIBRARY_ASSIGN_HISTORY.RESUME_LIBRARY_ASSIGN_HISTORY_ERROR,
        })
      },
      {
        params: {
          page: page,
        },
      },
      METHOD.GET,
      { showToast: false }
    )
  }

/**
 * activity
 * @param resumeId
 * @returns
 */
const getResumeActivityThunk =
  (resumeId): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: RESUME_ACTIVITY.RESUME_ACTIVITY_INITIALIZATION,
    })
    apiCall(
      RESUME_ACTIVITY_URL(resumeId),
      (res: any) => {
        dispatch({
          type: RESUME_ACTIVITY.RESUME_ACTIVITY_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: RESUME_ACTIVITY.RESUME_ACTIVITY_ERROR,
        })
      },
      {},
      METHOD.GET,
      { showToast: false }
    )
  }
/**
 * get resume pdf
 * @param userId
 * @param uuid
 * @returns
 */
const getResumeFileThunk = (
  userId,
  uuid
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_RESUME_FILE?.GET_RESUME_FILE_INITIALIZATION,
    })
    apiCall(
      `${process.env.REACT_APP_RESUME_READER_URL}${GET_RESUME_LINK_URL}`,
      (res) => {
        dispatch({
          type: GET_RESUME_FILE.GET_RESUME_FILE_SUCCESS,
          payload: res,
        })
      },
      () => {
        dispatch({
          type: GET_RESUME_FILE.GET_RESUME_FILE_ERROR,
        })
        showErrorToastMessage('Something went wrong')
      },
      { params: { user_id: userId, prefix: uuid } },
      METHOD.GET,
      { showToast: false }
    )
  }
}
/**
 * bulk resume download
 * @param payload
 * @returns
 */

const getResumeBulkFileThunk = (
  payload
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: RESUME_BULK_DOWNLOAD.RESUME_BULK_DOWNLOAD_INITIALIZATION,
    })
    apiCall(
      `${process.env.REACT_APP_RESUME_READER_URL}${RESUME_BULK_DOWNLOAD_URL}`,
      (res) => {
        dispatch({
          type: RESUME_BULK_DOWNLOAD.RESUME_BULK_DOWNLOAD_SUCCESS,
          payload: res,
        })
      },
      () => {
        dispatch({
          type: RESUME_BULK_DOWNLOAD.RESUME_BULK_DOWNLOAD_ERROR,
        })

        showErrorToastMessage('Something went wrong')
      },
      { resume_data: payload },
      METHOD.POST,
      { showToast: false }
    )
  }
}

/**
 * assign batch list
 * @returns
 */
const getAssignBatchListThunk = (): ThunkAction<
  void,
  Store,
  unknown,
  Action<string>
> => {
  return (dispatch) => {
    dispatch({
      type: GET_ASSIGN_BATCH_LIST.GET_ASSIGN_BATCH_LIST_INITIALIZATION,
    })

    apiCall(
      ASSIGN_TO_BATCH_LIST_URL,
      (res) => {
        dispatch({
          type: GET_ASSIGN_BATCH_LIST.GET_ASSIGN_BATCH_LIST_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_ASSIGN_BATCH_LIST.GET_ASSIGN_BATCH_LIST_ERROR,
        })
      },
      {},
      METHOD.GET,
      { showToast: false }
    )
  }
}

const getAssignBatchSkillMatchListThunk = (
  batchId,
  resumeIds,
  search
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_ASSIGN_TO_BATCH_SKILL_MATCH.GET_ASSIGN_TO_BATCH_SKILL_MATCH_INITIALIZATION,
    })

    apiCall(
      ASSIGN_TO_BATCH_SKILL_MATCH_URL(batchId),
      (res) => {
        dispatch({
          type: GET_ASSIGN_TO_BATCH_SKILL_MATCH.GET_ASSIGN_TO_BATCH_SKILL_MATCH_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_ASSIGN_TO_BATCH_SKILL_MATCH.GET_ASSIGN_TO_BATCH_SKILL_MATCH_ERROR,
        })
      },
      {
        params: {
          resume_list: JSON.stringify(resumeIds),
          search: search ? search : undefined,
        },
      },
      METHOD.GET,
      { showToast: false }
    )
  }
}

/**
 * bulk delete
 * @param resumeIds
 * @returns
 */
const resumeBulkDeleteThunk = (
  resumeIds,
  modalHandler
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: RESUME_BULK_DELETE.RESUME_BULK_DELETE_INITIALIZATION,
    })

    apiCall(
      RESUME_BULK_DELETE_URL,
      () => {
        dispatch({
          type: RESUME_BULK_DELETE.RESUME_BULK_DELETE_SUCCESS,
        })
        modalHandler()
      },
      () => {
        dispatch({
          type: RESUME_BULK_DELETE.RESUME_BULK_DELETE_ERROR,
        })
      },
      {
        resumes: JSON.stringify(resumeIds),
      },
      METHOD.PATCH,
      { showToast: false }
    )
  }
}

/**
 * bulk bookmark
 * @param resumeIds
 * @returns
 */
const resumeBulkBookmarkThunk = (
  resumeIds,
  modalHandler
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: RESUME_BULK_BOOKMARK.RESUME_BULK_BOOKMARK_INITIALIZATION,
    })

    apiCall(
      RESUME_BULK_BOOKMARK_URL,
      () => {
        dispatch({
          type: RESUME_BULK_BOOKMARK.RESUME_BULK_BOOKMARK_SUCCESS,
        })
        modalHandler()
      },
      () => {
        dispatch({
          type: RESUME_BULK_BOOKMARK.RESUME_BULK_BOOKMARK_ERROR,
        })
      },
      {
        resume_data: JSON.stringify(resumeIds),
      },
      METHOD.POST,
      { showToast: false }
    )
  }
}

/**
 * get jd list for filter
 * @returns
 */
const getJDListThunk = (): ThunkAction<
  void,
  Store,
  unknown,
  Action<string>
> => {
  return (dispatch) => {
    dispatch({
      type: GET_JD_LIST.GET_JD_LIST_INITIALIZATION,
    })

    apiCall(
      JD_LIST_URL,
      (res) => {
        dispatch({
          type: GET_JD_LIST.GET_JD_LIST_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_JD_LIST.GET_JD_LIST_ERROR,
        })
      },
      {
        params: {
          status: 'A',
        },
      },
      METHOD.GET,
      { showToast: false }
    )
  }
}

/**
 * get jd details
 * @returns
 */
const getJdDetailsThunk = (
  jdId
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: GET_JD_DETAILS.GET_JD_DETAILS_INITIALIZATION,
    })

    apiCall(
      JD_DETAILS_URL(jdId),
      (res) => {
        dispatch({
          type: GET_JD_DETAILS.GET_JD_DETAILS_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_JD_LIST.GET_JD_LIST_ERROR,
        })
      },
      {},
      METHOD.GET,
      { showToast: false }
    )
  }
}
/**
 * assign resume to batch
 * @param resumeData
 * @returns
 */
const resumeAssignToBatchThunk = (
  batchId,
  resumeData,
  redirectHandler
): ThunkAction<void, Store, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({
      type: RESUME_ASSIGN_TO_BATCH.RESUME_ASSIGN_TO_BATCH_INITIALIZATION,
    })

    apiCall(
      RESUME_ASSIGN_TO_BATCH_URL(batchId),
      () => {
        dispatch({
          type: RESUME_ASSIGN_TO_BATCH.RESUME_ASSIGN_TO_BATCH_SUCCESS,
        })
        redirectHandler()
      },
      () => {
        dispatch({
          type: RESUME_ASSIGN_TO_BATCH.RESUME_ASSIGN_TO_BATCH_ERROR,
        })
      },
      {
        resume_data: resumeData,
      },
      METHOD.POST,
      { showToast: false }
    )
  }
}

export {
  getResumeLibraryListThunk,
  getResumeDetailThunk,
  getResumeAssignHistoryThunk,
  getResumeActivityThunk,
  getAssignBatchListThunk,
  getAssignBatchSkillMatchListThunk,
  resumeBulkDeleteThunk,
  resumeBulkBookmarkThunk,
  getJDListThunk,
  resumeAssignToBatchThunk,
  getJdDetailsThunk,
  getResumeFileThunk,
  getResumeBulkFileThunk,
}
